// Demo-only identity/backlink helpers for the four Antares mockup scans.
//
// The RC scan-details page identifies its tool through the platform's `Tool` enum, which does not
// include Antares. To render Antares branding without editing the enum (which would break the
// OpenAPI parity check), the four demo scans wire `detector: 'codeql'` on the wire and this helper
// injects Antares identity at the two places the header renders it (name + icon).
//
// Also exposes the slug ↔ scan-id mapping so the RC page can offer a backlink to /antares-scans.

import { antaresRunCatalog } from '../mock-data/antares-scans/index.ts'

const scanIdToSlug = new Map(antaresRunCatalog.map(entry => [entry.report.run_id, entry.slug]))

const repositoryIdToSlug = new Map(antaresRunCatalog.map(entry => [`antares-repo-${entry.slug}`, entry.slug]))

export const ANTARES_DEMO_TOOL_NAME = 'Antares × Pixee'

export const ANTARES_DEMO_REPOSITORY_IDS: readonly string[] = antaresRunCatalog.map(
  entry => `antares-repo-${entry.slug}`
)

export const isAntaresDemoScanId = (scanId: string | undefined): boolean =>
  scanId !== undefined && scanIdToSlug.has(scanId)

export const isAntaresDemoRepositoryId = (repositoryId: string | undefined): boolean =>
  repositoryId !== undefined && repositoryIdToSlug.has(repositoryId)

export const getAntaresDemoSlugForScanId = (scanId: string | undefined): string | undefined => {
  if (scanId === undefined) {
    return undefined
  }
  return scanIdToSlug.get(scanId)
}

export const getAntaresDemoSlugForRepositoryId = (repositoryId: string | undefined): string | undefined => {
  if (repositoryId === undefined) {
    return undefined
  }
  return repositoryIdToSlug.get(repositoryId)
}
